import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-operation",
  "use": "icon-operation-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"icon-operation\"><defs><style>#icon-operation .a{fill:#4d2ef4;}</style></defs><path class=\"a\" d=\"M12.5,12a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5ZM.5,12a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,.5,10h10a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm12-5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5ZM.5,7A.5.5,0,0,1,0,6.5v-1A.5.5,0,0,1,.5,5h10a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm12-5a.5.5,0,0,1-.5-.5V.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5ZM.5,2A.5.5,0,0,1,0,1.5V.5A.5.5,0,0,1,.5,0h10a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z\" transform=\"translate(14 12) rotate(180)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/operation.svg
// module id = Dh6m
// module chunks = 115